/* eslint-disable max-statements */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import { packageOperations, packageTypes } from '../../store/package';

import { DAS_GET_TICKETS_AVAILABILITY_FAILED } from '../../constants/errors';
import { createError } from '../../store/errors';
import { getTicketsAvailability } from '../../api/tickets';

const { getTicketsAvailabilitySuccess } = packageOperations;
const { GET_TICKETS_AVAILABILITY } = packageTypes;

export const performGetTicketsAvailability = function* performGetTicketsAvailability({
  payload,
}) {
  try {
    const { bookingRef } = payload;

    const ticketsAvailabilityResponse = yield call(
      getTicketsAvailability,
      bookingRef,
    );

    if (ticketsAvailabilityResponse.error) {
      yield put(createError(ticketsAvailabilityResponse.error));
      return;
    }

    if (ticketsAvailabilityResponse.errors) {
      yield all(
        ticketsAvailabilityResponse.errors.map(error =>
          put(createError(error)),
        ),
      );
      return;
    }

    yield put(
      getTicketsAvailabilitySuccess(
        bookingRef,
        ticketsAvailabilityResponse.tickets,
      ),
    );
  } catch (error) {
    yield put(
      createError({
        code: DAS_GET_TICKETS_AVAILABILITY_FAILED,
      }),
    );
  }
};

export default takeLatest(
  GET_TICKETS_AVAILABILITY,
  performGetTicketsAvailability,
);
